<template>
    <div class="form-file-pp">
        <label for="" v-if="currentLabel">{{ currentLabel }}</label>

        <b-form-file
            v-model="filesSelected"
            placeholder="Solte seu arquivo aqui ou clique para fazer o upload"
            drop-placeholder="Drop file here..."
            browse-text="Upload"
            variant="primary"
            multiple
            :disabled="isDisabled"
            :accept="typesAccept"
            v-if="!isSingleFile"
        ></b-form-file>

        <b-form-file
            v-model="singleFileSelected"
            placeholder="Solte seu arquivo aqui ou clique para fazer o upload"
            drop-placeholder="Drop file here..."
            browse-text="Upload"
            variant="primary"
            :accept="typesAccept"
            :disabled="isDisabled"
            v-if="isSingleFile && showSingleFile"
        ></b-form-file>

        <!-- <div class="form-files-control">
            <div v-if="!isSingleFile">
                <div v-if="currentFiles.length">
                    <ul>
                        <li
                            v-for="(file, index) in currentFiles"
                            :key="index"
                            @mouseover="showCloseBtn(index)"
                            @mouseleave="hideCloseBtn(index)"
                            @click="removeFile(index)"
                        >
                            <img :src="require(`@/assets/pdf.svg`)" alt="pdf" v-if="file.type.indexOf('pdf') !== -1" />
                            <img
                                :src="require(`@/assets/picture.svg`)"
                                alt="picture"
                                v-if="
                                    file.type.indexOf('png') !== -1 ||
                                        file.type.indexOf('jpg') !== -1 ||
                                        file.type.indexOf('jpeg') !== -1
                                "
                            />

                            <div class="file-name">{{ file.name }}</div>

                            <div class="close-btn" style="display: none;" :ref="`btn-close-${index}`">
                                <span class="text">x</span>
                            </div>
                        </li>
                    </ul>
                </div>

                <div v-else class="texts">
                    <div class="text1">{{ currentText1 }}</div>

                    <div class="text2">{{ currentText2 }}</div>
                </div>
            </div>
            <div v-else>
                <div v-if="singleFileSelected">
                    <ul>
                        <li>
                            <img
                                :src="require(`@/assets/pdf.svg`)"
                                alt="pdf"
                                v-if="singleFileSelected.type.indexOf('pdf') !== -1"
                            />
                            <img
                                :src="require(`@/assets/picture.svg`)"
                                alt="picture"
                                v-if="
                                    singleFileSelected.type.indexOf('png') !== -1 ||
                                        singleFileSelected.type.indexOf('jpg') !== -1 ||
                                        singleFileSelected.type.indexOf('jpeg') !== -1
                                "
                            />

                            <div class="file-name">{{ singleFileSelected.name }}</div>
                        </li>
                    </ul>
                </div>

                <div v-else class="texts">
                    <div class="text1">{{ currentText1 }}</div>

                    <div class="text2">{{ currentText2 }}</div>
                </div>
            </div>
        </div> -->

        <div class="form-files-control" v-if="!currentFiles.length && !singleFileSelected">
            <div class="texts">
                <div class="text1">{{ currentText1 }}</div>

                <div class="text2">{{ currentText2 }}</div>
            </div>
        </div>

        <div
            class="form-files-control preview-single-img"
            v-if="showPreviewImg && isSingleFile && isSingleFileSelected"
        >
            <div class="btn-close" @click="removeSingleFile()" v-if="!disabled">
                <button class="btn btn-danger">x</button>
            </div>

            <img :src="urlSingleFile" alt="" />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            singleFileSelected: null,
            filesSelected: [],
            currentFiles: [],
            currentText1: null,
            currentText2: null,
            isSingleFile: null,
            typesAccept: null,
            urlSingleFile: null,
            currentLabel: null,
            showPreviewImg: null,
            image: null
        }
    },
    props: {
        singleFileData: null,
        urlSingleFileData: null,
        label: {
            type: String,
            default: null
        },
        text1: {
            type: String,
            default: ''
        },
        text2: {
            type: String,
            default: ''
        },
        singleFile: {
            type: Boolean,
            default: false
        },
        previewImg: {
            type: Boolean,
            default: false
        },
        accept: {
            type: String,
            default: 'image/jpeg, image/jpg, image/png, application/pdf'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        showSingleFile: {
            type: Boolean,
            default: true
        }
    },
    watch: {
        filesSelected: function(val) {
            this.currentFiles = this.currentFiles.concat(val)
        },
        singleFileSelected: function(val) {
            if (this.singleFileSelected && this.singleFileSelected.name.indexOf('uploads/') === -1) {
                this.singleFileSelected = val
                this.urlSingleFile = window.URL.createObjectURL(this.singleFileSelected)

                let reader = new FileReader()
                reader.onload = e => {
                    this.image = e.target.result
                    this.$emit('fileSelected', true)
                }

                reader.readAsDataURL(val)
            }
        }
    },
    computed: {
        isDisabled() {
            return this.disabled
        },
        isSingleFileSelected() {
            return this.singleFileSelected
        }
    },
    methods: {
        removeFile(indexFile) {
            this.currentFiles = this.currentFiles.filter((item, index) => index !== indexFile)
        },
        removeSingleFile() {
            this.singleFileSelected = null
            this.$emit('removeSingleFile')
        },
        showCloseBtn(index) {
            this.$refs[`btn-close-${index}`][0].style.display = 'block'
        },
        hideCloseBtn(index) {
            this.$refs[`btn-close-${index}`][0].style.display = 'none'
        },
        onChangeSingleFile(file) {
            // console.log('file >>>', file)
        }
    },
    mounted() {
        this.singleFileSelected = this.singleFileData
        this.urlSingleFile = this.urlSingleFileData
        this.currentText1 = this.text1
        this.currentText2 = this.text2
        this.isSingleFile = this.singleFile
        this.typesAccept = this.accept
        this.currentLabel = this.label
        this.showPreviewImg = this.previewImg
    }
}
</script>

<style scope src="./FormFilePP-light-theme.css"></style>
<style scope src="./FormFilePP-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/ui/form-file-pp/FormFilePP.vue